import Link from 'next/link'
import { FC, memo } from 'react'

import { buttonVariants } from '@fp/ui-kit'
import { cn } from '@lib/cn'
import { TRADING_APP_URL } from '@lib/constants'

export const TradingAccountLink: FC<{ login?: string; className?: string; prefix?: string }> = memo(
  ({ login, className = '', prefix = '' }) =>
    typeof login === 'string' && TRADING_APP_URL ? (
      <Link
        href={`${TRADING_APP_URL}/accounts/${login}`}
        className={cn(buttonVariants({ variant: 'linkNoPadding' }), className)}
      >
        {`${prefix}${login}`}
      </Link>
    ) : (
      <span>{login}</span>
    ),
)
